import Message from 'ant-design-vue/lib/message';
import 'ant-design-vue/lib/message/style/css';
const fun=(apiName,arg,cb)=>{
    apiName(arg).then(res=>{
        if(res.code===200){
            cb(res)
        }else{
            Message.error(res.message)
        }
    }).catch(err=>{
        console.log(err)
        //Message.error('出错了')
    }) 
}
export default fun